/**
 *
 * Module:        Component
 * Name:          Guru Chat Dialog Buttons
 * Description:   Provides consistent primary, secondary and destructive dialog actions
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';

export const GuruDialogSecondaryButton = styled(Button)({
	backgroundColor: '#fff !important',
	color: 'var(--primary-color, #004c3f) !important',
	borderColor: 'var(--primary-color, #004c3f) !important',
	'&:hover': {
		backgroundColor: 'rgba(0, 76, 63, 0.06) !important',
		borderColor: 'var(--primary-color, #004c3f) !important'
	}
});

export const GuruDialogPrimaryButton = styled(Button)({
	backgroundColor: 'var(--primary-color, #004c3f) !important',
	color: '#fff !important',
	'&:hover': {filter: 'brightness(0.88)'},
	'&.Mui-disabled': {
		backgroundColor: '#9db8b3 !important',
		color: '#fff !important'
	}
});

export const GuruDialogDangerButton = styled(Button)({
	backgroundColor: '#d32f2f !important',
	color: '#fff !important',
	'&:hover': {backgroundColor: '#b71c1c !important'},
	'&.Mui-disabled': {
		backgroundColor: '#ef9a9a !important',
		color: '#fff !important'
	}
});
